/** Shared color palette for Topics, Triggers, Roots charts - mid-saturation between vivid and pastel */
export const SHARED_CHART_COLORS = [
  '#818cf8', '#a78bfa', '#38bdf8', '#f472b6', '#fb923c', '#4ade80',
  '#22d3ee', '#c084fc', '#f87171', '#fbbf24', '#34d399', '#94a3b8',
];
